import React, { lazy } from 'react';
import { scrollToPurchase } from '../utils/scroll';
const TOMOS = [{
  num: '01',
  title: 'Mentalidad de Cierre',
  subtitle: 'El fin del miedo al "no".',
  desc: 'Reprograma la psicología que te hace bajar el precio, disculparte por vender y evitar el seguimiento. El fundamento de todo lo demás.'
}, {
  num: '02',
  title: 'Estructura de Conversación',
  subtitle: 'El mapa paso a paso.',
  desc: 'Aprende exactamente qué decir en cada fase del chat: apertura, diagnóstico, presentación y cierre. Sin improvisar.'
}, {
  num: '03',
  title: 'El Poder de las Preguntas',
  subtitle: 'Quien pregunta, domina.',
  desc: 'Las preguntas correctas revelan el dolor real del cliente, eliminan objeciones antes de que aparezcan y posicionan tu precio como lógico.'
}, {
  num: '04',
  title: 'El Cierre Maestro',
  subtitle: 'Técnicas de transición final.',
  desc: 'El momento exacto y la forma técnica de pedir la compra sin sonar presionador y sin que el cliente sienta "dolor de pago".'
}, {
  num: '05',
  title: 'Seguimiento Sin Persecución',
  subtitle: 'Cómo volver a un chat muerto.',
  desc: 'La diferencia entre el seguimiento que molesta y el que convierte. Recupera prospectos que diste por perdidos.'
}];
export function ProductPresentation() {
  return <section className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8 lg:py-24 border-t border-white/5" data-id="element-101">
      <div className="mx-auto max-w-5xl" data-id="element-102">
        {/* Intro */}
        <div className="text-center mb-16 bg-white rounded-3xl p-8 sm:p-12" data-id="element-103">
          <div className="mb-6 inline-block rounded-full bg-brand-green/20 px-4 py-1.5 text-sm font-bold text-brand-green" data-id="element-104">
            PRESENTANDO
          </div>
          <h2 className="mb-4 font-black text-brand-black sm:text-6xl tracking-tight text-[32px]" data-id="element-105">
            Cierre Maestro 2.0
          </h2>
          <h3 className="mb-10 text-xl font-medium text-gray-600 sm:text-2xl" data-id="element-106">
            El método completo para cerrar una venta tras otra
          </h3>

          <div className="mx-auto mb-10 max-w-3xl cursor-pointer transition-transform hover:scale-[1.02]" onClick={scrollToPurchase} data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/8BymP3xMsw4RGti6Va9zF6/mockup_premium_2.webp" alt="Cierre Maestro 2.0 - Edición Premium" className="w-full rounded-xl shadow-xl" width="662" height="662" loading="lazy" decoding="async" data-id="element-108" />
          </div>

          <div className="space-y-4 text-lg font-medium text-gray-700" data-id="element-109">
            <p className="line-through decoration-red-500 decoration-2" data-id="element-110">
              No es un libro de frases mágicas.
            </p>
            <p className="line-through decoration-red-500 decoration-2" data-id="element-111">
              No es un curso de 40 horas.
            </p>
            <p className="line-through decoration-red-500 decoration-2" data-id="element-112">
              No es teoría de marketing genérica.
            </p>
            <p className="mt-6 text-xl font-bold text-brand-black bg-gray-100 p-4 rounded-lg" data-id="element-113">
              Es un sistema de 5 tomos de consumo rápido, diseñado para que leas
              uno hoy y lo apliques en tu próximo chat.
            </p>
          </div>
        </div>

        {/* The 5 Tomos Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-114">
          {TOMOS.map((tomo, idx) => <div key={idx} className="group relative rounded-2xl border border-brand-green/30 bg-brand-darkGray p-8 transition-all hover:border-brand-green hover:shadow-[0_0_30px_rgba(37,211,102,0.15)] hover:-translate-y-1" data-id="element-115">
              <div className="mb-4 text-sm font-bold tracking-widest text-brand-green" data-id="element-116">
                TOMO {tomo.num}
              </div>
              <h4 className="mb-2 text-2xl font-bold text-white" data-id="element-117">
                {tomo.title}
              </h4>
              <p className="mb-4 font-medium text-brand-green" data-id="element-118">
                {tomo.subtitle}
              </p>
              <p className="text-gray-400 leading-relaxed" data-id="element-119">{tomo.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}